/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiFileManagerDownloadPost } from '../fn/file-manager/api-file-manager-download-post';
import { ApiFileManagerDownloadPost$Params } from '../fn/file-manager/api-file-manager-download-post';
import { apiFileManagerDownloadPost$Plain } from '../fn/file-manager/api-file-manager-download-post-plain';
import { ApiFileManagerDownloadPost$Plain$Params } from '../fn/file-manager/api-file-manager-download-post-plain';
import { apiFileManagerFileManagerOperationsPost } from '../fn/file-manager/api-file-manager-file-manager-operations-post';
import { ApiFileManagerFileManagerOperationsPost$Params } from '../fn/file-manager/api-file-manager-file-manager-operations-post';
import { apiFileManagerGetImageGet } from '../fn/file-manager/api-file-manager-get-image-get';
import { ApiFileManagerGetImageGet$Params } from '../fn/file-manager/api-file-manager-get-image-get';
import { apiFileManagerUploadPost } from '../fn/file-manager/api-file-manager-upload-post';
import { ApiFileManagerUploadPost$Params } from '../fn/file-manager/api-file-manager-upload-post';

@Injectable({ providedIn: 'root' })
export class FileManagerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiFileManagerFileManagerOperationsPost()` */
  static readonly ApiFileManagerFileManagerOperationsPostPath = '/api/FileManager/FileManagerOperations';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileManagerFileManagerOperationsPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFileManagerFileManagerOperationsPost$Response(params?: ApiFileManagerFileManagerOperationsPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiFileManagerFileManagerOperationsPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileManagerFileManagerOperationsPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFileManagerFileManagerOperationsPost(params?: ApiFileManagerFileManagerOperationsPost$Params, context?: HttpContext): Observable<void> {
    return this.apiFileManagerFileManagerOperationsPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiFileManagerUploadPost()` */
  static readonly ApiFileManagerUploadPostPath = '/api/FileManager/Upload';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileManagerUploadPost()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiFileManagerUploadPost$Response(params?: ApiFileManagerUploadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiFileManagerUploadPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileManagerUploadPost$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiFileManagerUploadPost(params?: ApiFileManagerUploadPost$Params, context?: HttpContext): Observable<void> {
    return this.apiFileManagerUploadPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiFileManagerDownloadPost()` */
  static readonly ApiFileManagerDownloadPostPath = '/api/FileManager/Download';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileManagerDownloadPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFileManagerDownloadPost$Plain$Response(params?: ApiFileManagerDownloadPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiFileManagerDownloadPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileManagerDownloadPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFileManagerDownloadPost$Plain(params?: ApiFileManagerDownloadPost$Plain$Params, context?: HttpContext): Observable<Blob> {
    return this.apiFileManagerDownloadPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileManagerDownloadPost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFileManagerDownloadPost$Response(params?: ApiFileManagerDownloadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
    return apiFileManagerDownloadPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileManagerDownloadPost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiFileManagerDownloadPost(params?: ApiFileManagerDownloadPost$Params, context?: HttpContext): Observable<Blob> {
    return this.apiFileManagerDownloadPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<Blob>): Blob => r.body)
    );
  }

  /** Path part for operation `apiFileManagerGetImageGet()` */
  static readonly ApiFileManagerGetImageGetPath = '/api/FileManager/GetImage';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiFileManagerGetImageGet()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiFileManagerGetImageGet$Response(params?: ApiFileManagerGetImageGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiFileManagerGetImageGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiFileManagerGetImageGet$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  apiFileManagerGetImageGet(params?: ApiFileManagerGetImageGet$Params, context?: HttpContext): Observable<void> {
    return this.apiFileManagerGetImageGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
